import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { pinia } from '@/js/lib/store';
import { useItemStore } from '@/js/lib/store/item';
import LikeButtonSmall from '@/js/components/www.iichi.com/organisms/LikeButtonSmall.vue';
import TopSlider from '@/js/components/www.iichi.com/pages/index/TopSlider.vue';

document.addEventListener('DOMContentLoaded', () => {
  const sliderEl = document.querySelector('top-slider') as HTMLElement;
  createApp({
    render: () =>
      h(TopSlider, {
        slidesJson: sliderEl.dataset.slides!,
        imageWidth: Number(sliderEl.dataset.imageWidth),
        imageHeight: Number(sliderEl.dataset.imageHeight),
      }),
  }).mount(sliderEl);

  const likeButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('like-button-small');
  if (likeButtonEls.length > 0) {
    const itemStore = useItemStore(pinia);
    const itemIds = Array.from(likeButtonEls, (el) => Number(el.dataset.itemId));
    itemStore.checkLiked(uniq(itemIds));

    likeButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(LikeButtonSmall, {
            itemId: Number(el.dataset.itemId),
          }),
      }).mount(el);
    });
  }
});
